import type { TriggerRenderer } from "../types";
import { octopusTriggerRenderer } from "./common";

export const onDeploymentEventTriggerRenderer: TriggerRenderer = octopusTriggerRenderer;
